export const scheduleClass = [
	{
		
		id: "S148239",
		type: "Class",
		startTime: "09:30 AM",
		endTime: "10:30 AM",
		status: "Active",
		key:1
	  },
	  {
		
		id: "S148238",
		type: "Class",
		startTime: "10:30 AM",
		endTime: "11:30 AM",
		status: "Active",
		key:2
	  },
	  {
		
		id: "S148237",
		type: "Class",
		startTime: "11:30 AM",
		endTime: "12:30 PM",
		status: "Active",
		key:3
	  },
	  {
		
		id: "S148236",
		type: "Class",
		startTime: "12:30 PM",
		endTime: "01:30 PM",
		status: "Active",
		key:4
	  },
	  {
		
		id: "S148235",
		type: "Class",
		startTime: "01:30 PM",
		endTime: "02:30 PM",
		status: "Active",
		key:5
	  },
	  {
		
		id: "S148234",
		type: "Class",
		startTime: "02:30 PM",
		endTime: "03:30 PM",
		status: "Active",
		key:6
	  },
	  {
		
		id: "S148233",
		type: "Class",
		startTime: "03:30 PM",
		endTime: "04:30 PM",
		status: "Active",
		key:7
	  },
	  {
		
		id: "S148232",
		type: "Class",
		startTime: "04:30 PM",
		endTime: "05:30 PM",
		status: "Active",
		key:8
	  },
	  {
		
		id: "S148231",
		type: "Class",
		startTime: "05:30 PM",
		endTime: "06:30 PM",
		status: "Active",
		key:9
	  },
	  {
		
		id: "S148230",
		type: "Class",
		startTime: "06:30 PM",
		endTime: "07:30 PM",
		status: "Inactive",
		key:10
	  }
];
